/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Chip_OnInputs */

const vi_shop_home_chip_on = /** @type {(inputs: Shop_Home_Chip_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(đang hiện)`)
};

/**

* @param {Shop_Home_Chip_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_chip_on = /** @type {((inputs?: Shop_Home_Chip_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Chip_OnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_chip_on(inputs)
});